import React from "react";
import { Routes, Route } from "react-router-dom";
import ListNewsBrand from "../Components/News Brand/listNewsBrand";
import AddNewsBrand from "../Components/News Brand/addNewsBrand";
import EditBrandNews from "../Components/News Brand/editNewsBrand";
import ViewBrandNews from "../Components/News Brand/viewNewsBrand";
const NewsBrandRoutes = () => {
  return (
    <Routes>
      <Route path="/fa_brands" element={<ListNewsBrand></ListNewsBrand>}></Route>
      <Route
        path="/fa_brands/add"
        element={<AddNewsBrand></AddNewsBrand>}
      ></Route>
      <Route
        path="/fa_brands/edit/:id"
        element={<EditBrandNews></EditBrandNews>}
      ></Route>
      <Route
        path="/fa_brands/view/:id"
        element={<ViewBrandNews></ViewBrandNews>}
      ></Route>
    </Routes>
  );
};

export default NewsBrandRoutes;
